import Tabs from './Tabs/'
import Container from './Container/'
import Collapse from './Collapse/'
import Collumns from './Collumns'

export default {
  Collumns,
  Tabs,
  Collapse,
  Container
}
